var map = {
	"./delete.svg": 10154,
	"./emojis/angry_with_horns.png": 24798,
	"./emojis/avocado.png": 5728,
	"./emojis/banana.png": 70648,
	"./emojis/banjo.png": 75125,
	"./emojis/beer_mug.png": 52277,
	"./emojis/blessed.png": 81225,
	"./emojis/call_me.png": 90110,
	"./emojis/cherry.png": 5628,
	"./emojis/clap.png": 25305,
	"./emojis/claps.png": 39718,
	"./emojis/cold_face.png": 84049,
	"./emojis/collision.png": 20195,
	"./emojis/confetti.png": 29083,
	"./emojis/cookies.png": 27230,
	"./emojis/cowboy_face.png": 65844,
	"./emojis/crossed.png": 82384,
	"./emojis/crying_face.png": 22159,
	"./emojis/data.csv": 89235,
	"./emojis/desert_island.png": 84454,
	"./emojis/dizzy.png": 24821,
	"./emojis/dollar_struck.png": 2610,
	"./emojis/dynamite.png": 92346,
	"./emojis/exploding_face.png": 41029,
	"./emojis/fries.png": 37106,
	"./emojis/ghost_face.png": 64120,
	"./emojis/giving_left.png": 2105,
	"./emojis/giving_right.png": 72450,
	"./emojis/grape.png": 22170,
	"./emojis/grapes.png": 31835,
	"./emojis/grinning.png": 86155,
	"./emojis/hand.png": 6424,
	"./emojis/hand_holding_pencil_left.png": 82284,
	"./emojis/hand_holding_pencil_right.png": 62345,
	"./emojis/heart_eyes.png": 29014,
	"./emojis/heart_on_fire.png": 8692,
	"./emojis/high_voltage.png": 95528,
	"./emojis/horns.png": 10241,
	"./emojis/huffing_with_anger.png": 39697,
	"./emojis/hugging.png": 99482,
	"./emojis/ice_cream.png": 50049,
	"./emojis/kissing.png": 85125,
	"./emojis/laughing.png": 37006,
	"./emojis/leaf_fluttering_in_wind.png": 17625,
	"./emojis/love.png": 54123,
	"./emojis/meat_bone.png": 15501,
	"./emojis/middle_finger.png": 8382,
	"./emojis/musical_notes.png": 96771,
	"./emojis/nerd.png": 34114,
	"./emojis/ok.png": 84285,
	"./emojis/ok_right.png": 24754,
	"./emojis/oncoming_fist.png": 40788,
	"./emojis/open_hands.png": 83792,
	"./emojis/partying.png": 79431,
	"./emojis/pile_of_poo.png": 47092,
	"./emojis/pinch.png": 18191,
	"./emojis/pinching_left.png": 23855,
	"./emojis/pinching_right.png": 23616,
	"./emojis/point_up.png": 43177,
	"./emojis/point_up_face.png": 26373,
	"./emojis/pointing_down.png": 4418,
	"./emojis/pointing_left.png": 54577,
	"./emojis/pointing_right.png": 97530,
	"./emojis/pointing_right_2.png": 54357,
	"./emojis/pointing_up.png": 68653,
	"./emojis/poke.png": 70415,
	"./emojis/pouting.png": 19183,
	"./emojis/pray.png": 24143,
	"./emojis/punch_left.png": 45251,
	"./emojis/punch_right.png": 72972,
	"./emojis/rainbow.png": 36341,
	"./emojis/raised_fist.png": 76778,
	"./emojis/raising_hands.png": 15709,
	"./emojis/robot.png": 53235,
	"./emojis/rolling_eyes.png": 30319,
	"./emojis/rose.png": 23622,
	"./emojis/sad.png": 51967,
	"./emojis/saxophone.png": 37262,
	"./emojis/sign_of_the_horns.png": 26169,
	"./emojis/skull.png": 28384,
	"./emojis/sleeping.png": 55700,
	"./emojis/smile.png": 39967,
	"./emojis/smiling_with_hearts.png": 53883,
	"./emojis/smiling_with_horns.png": 10184,
	"./emojis/sparkles.png": 47426,
	"./emojis/speaker_high_volume.png": 95696,
	"./emojis/squinting.png": 83755,
	"./emojis/star_struck.png": 8004,
	"./emojis/strawberry.png": 48016,
	"./emojis/sunglasses.png": 43685,
	"./emojis/sunglasses_face.png": 67553,
	"./emojis/swearing.png": 24657,
	"./emojis/thinking.png": 99467,
	"./emojis/thumbs_down.png": 725,
	"./emojis/thumbs_up.png": 43102,
	"./emojis/tin.png": 70218,
	"./emojis/unicorn.png": 62467,
	"./emojis/victory.png": 93913,
	"./emojis/violin.png": 39972,
	"./emojis/vomiting_face.png": 61030,
	"./emojis/vulcan_salute.png": 39971,
	"./emojis/watermelon.png": 40509,
	"./emojis/wave.png": 70528,
	"./emojis/winking.png": 46424,
	"./emojis/winking_2.png": 44027,
	"./emojis/with_monocle.png": 53347,
	"./emojis/zany_face.png": 25527,
	"./gradient.png": 78995,
	"./gradientFull.png": 59364,
	"./menu-concepts.svg": 88964,
	"./menu-cross.svg": 72733,
	"./menu-download-line.svg": 17326,
	"./menu-download-triangle.svg": 23116,
	"./menu-logout.svg": 84541,
	"./menu-profile.svg": 42998,
	"./menu-resources.svg": 17914,
	"./menu-video.svg": 47512,
	"./profile-logout.svg": 16569,
	"./shortcut-activity.svg": 46785,
	"./shortcut-inbox.svg": 73642,
	"./shortcut-story.svg": 65161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;